import React from 'react';
import { forceToArray } from '../../utils/Helper';

import './SocialMediaIcons.scss';

const SocialMediaIcons = ({ icons, title }) => {
  return (
    <>
      <section className="section-mainPage-followUs">
        {title}
        {forceToArray(icons).map((v) => (
          <a href={v.url} target="_blank" rel="noopener noreferrer">
            <img src={v.image} className="icon" alt={v.alt} />
          </a>
        ))}
      </section>
    </>
  );
};

export default SocialMediaIcons;
